<template>
    <div>
<!--      废弃-->
    </div>
</template>
<script>
export default {
    name: 'privacyPolicy',
    data () {
        return{

        }
    },
    created () {
    },
    methods: {
    },
    mounted () {

    },
    watch: {

    }
}
</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/pages/privacyPolicy.vue